module.exports = __webpack_public_path__ + "frontend/img/L_splashscreen.2601f02f.svg";